import axios from 'axios'
import config from './config'
import sso from './sso'
import {Message} from '@ss/mtd-vue'

const service = axios.create(config);
const cancelToken = axios.CancelToken;

let pending: Array<{
  url: string,
  cancel: Function
}> = [];

const removePending = (config: any) => {
  for (let p in pending) {
    if (pending.hasOwnProperty(p)) {
      let item: any = p;
      let list: any = pending[p];
      if ((config.params && config.params.no_need_cancel) || (config.data && config.data.no_need_cancel)) {
        return false
      }
      if (list.url === config.url + '&' + config.method) { // 当当前请求在数组中存在时执行函数体
        list.cancel();// 执行取消操作
        pending.splice(item, 1) // 把这条记录从数组中移除
      }
    }
  }
};

// POST传参序列化(添加请求拦截器)
service.interceptors.request.use(
  config => {
    removePending(config);
    config.cancelToken = new cancelToken((c) => {
      pending.push({url: config.url + '&' + config.method, cancel: c})
    });
    return config
  },
  error => {
    Message({
      type: 'warning',
      message: '报错信息'
    });
    return Promise.reject(error)
  }
);

service.interceptors.response.use((res) => {
  removePending(res.config);
  const data = res.data
  if (res.data.status == 401) {
    //开启跨应用信任和单设备拦截时使用，否则直接重定向到sso登入页
    if (res.data.data.code === '30005' || res.data.data.code === '30006') {
      window.location.href = res.data.data.url;
      return Promise.reject();
    } else {
      // 重定向到sso登入页
      sso.doLogin();
      return Promise.reject();
    }
  }
  // 2.检查数据
  if (data && data.code !== 0) {
    if (!res.config.hideErrorMessage) {
      Message({
        type: 'warning',
        message: `${data.message}`
      })
    }
    return Promise.reject(res);
  }
  return Promise.resolve(data);
}, (error) => {
  return Promise.reject(error);
});

export default service
